<template>
  <div class="text-center">
    <!-- scroll-strategy="none" https://github.com/vuetifyjs/vuetify/issues/18507-->
    <v-dialog scroll-strategy="none" v-model="dialog" width="500" >
      <v-card class="CookieCard" > 
        <v-card-title class="text-h5 grey lighten-2">
          {{ privacyData.dialogTitle }}
        </v-card-title>
        <v-card-text
          ><VuetifyRender :html="privacyData.dialogText"></VuetifyRender>
        </v-card-text>

        <v-card-text>
          <v-radio-group v-model="cookieChoiceRadio">
            <template v-slot:label>
            </template>
            <!-- PersonalPackage -->
            <v-radio value="1">
              <template v-slot:label>
                <div class="text-primary">{{privacyData.dialogPersonalPackageTitle}}</div>
              </template>
            </v-radio>
            <div class="pa-3 pl-12 .theme--light">
              <VuetifyRender :html="privacyData.dialogPersonalCookieText"></VuetifyRender>
            </div>

            <!-- StandardPackage -->
            <v-radio value="0" class="pt-3">
              <template v-slot:label>
                <div class="text-primary">{{privacyData.dialogStandardPackageTitle}}</div>
              </template>
            </v-radio>
            <div class="pa-3 pl-12 theme--light">
              <VuetifyRender :html="privacyData.dialogStandardCookieText"></VuetifyRender>
            </div>
          </v-radio-group>
            <div @click="cookieLink"  class="float-right font-weight-bold text-decoration-underline">{{
            privacyData.dialogMoreInfoCookieLinkText
          }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cookieAccepted()">
            {{privacyData.dialogAcceptButton}}
          </v-btn>
        </v-card-actions>        
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
/* background color of select options, otherwise it will be transperant */
.CookieCard {
  background-color: white !important;
}
</style>
<script setup>

const dataAll = useDataAll();
const { $analytics, $methods, $helpers } = useNuxtApp()
// const privacyData = dataAll.getKey("privacy", []);
const privacyData = {
  dialogTitle:                  dataAll.getStatic("privacy_widget_title", "Privacy preferences"),
  dialogAcceptButton:           dataAll.getStatic("privacy_widget_button", "Save"),
  dialogPersonalPackageTitle :  dataAll.getStatic("privacy_widget_personal_title", "Personal cookie package"),
  dialogStandardPackageTitle :  dataAll.getStatic("privacy_widget_standard_title", "Standard cookie package"),
  dialogMoreInfoCookieLinkText: dataAll.getStatic("privacy_widget_more_info", "Read more about our privacy here"),
  dialogText:                   dataAll.getStatic("privacy_widget_intro_text", "Choice your preferences"),
  dialogStandardCookieText:     dataAll.getStatic("privacy_widget_standard_text", ""),
  dialogPersonalCookieText:     dataAll.getStatic("privacy_widget_personal_text", "")
};

// load cookies
const cookie_policy_accepted = useCookie("cookie_policy_accepted", {
  maxAge: 24 * 60 * 60 * 365,
});
const cookie_policy_shown = useCookie("cookie_policy_shown", {
  maxAge: 24 * 60 * 60 * 365,
});
// init dialog vars
let dialog =ref( cookie_policy_shown.value != 1?true:false)
let cookieChoiceRadio = ref( cookie_policy_accepted.value==0?"0":"1")


function cookieLink() {
  dialog.value = false;
  // let DC = $methods.pageByItemType("DC")
  const DC = usePageOverviewStore().getPageByType("DC");
  if ($helpers.isset(DC.Code)){
    navigateTo($methods.pageLinkByCode(DC.Code));
  } else {
    alert('No Page found, contact us')
  }
}

// cookkie choice made 
function cookieAccepted() {
  cookie_policy_shown.value = 1;
  cookie_policy_accepted.value = cookieChoiceRadio.value
  dialog.value = false;
  if (cookieChoiceRadio.value ==1  ){
    $analytics.allConsentGranted()
    //reload page, so GTM header can be used
    // reloadNuxtApp()
  } else {
    $analytics.allConsentRevoked()
  };
}

</script>
